import { UseCaseInteractor } from '../../../kernel/use-case'
import { HeimdallRepository } from '../domain/heimdall.repository'

export const setOfflineParticipantUseCase: UseCaseInteractor<
  [heimdallRepository: HeimdallRepository],
  [jobUuid: string, currentUserId: string],
  boolean
> = (heimdallRepository: HeimdallRepository) => async (jobUuid: string, currentUserId: string) => {
  return heimdallRepository.setOfflineParticipant(jobUuid, currentUserId)
}
